// extracted by mini-css-extract-plugin
module.exports = {"landingSectionName":"LandingSectionName_landingSectionName__1HVOE"};